import { makeStyles } from '@material-ui/core/styles';
import { THEME } from 'GlobalStyles';
import { colors } from 'UI/res';
import { isDarkTheme } from 'UI/theme/darkTones';
import {
  flexAlignCenterJustifyCenter,
  flexAlignCenterSpaceBetween,
  rippleEffect
} from 'UI/utils/styles';

const sharedStyles = {
  ...flexAlignCenterJustifyCenter,
  padding: THEME.spacing(0.5, 1.2),
  borderRadius: '100%',
  width: '44px',
  height: '44px'
};

const { secondary, grey } = THEME.palette;
const iconSize = 20;

const DARK_HOVER_OVERLAY = 'rgba(255, 255, 255, 0.12)';
const DARK_RIPPLE_OVERLAY = 'rgba(255, 255, 255, 0.2)';

export const useStyles = makeStyles(theme => {
  const isDark = isDarkTheme(theme);
  return {
    darkAction: {
      ...rippleEffect(secondary.dark, secondary.FPlight),
      ...sharedStyles
    },
    action: {
      ...(isDark
        ? rippleEffect(DARK_HOVER_OVERLAY, DARK_RIPPLE_OVERLAY)
        : rippleEffect(colors.lightgrey, '#717172')),
      ...sharedStyles,
      ...(isDark && {
        '&:hover svg': { fill: theme.palette.text.primary }
      })
    },
    container: {
      ...flexAlignCenterSpaceBetween
    },
    disabledIcon: {
      fill: `${
        isDark ? theme.palette.grey.A400 : theme.palette.customColors.disabledIcon
      } !important`
    },
    disabledLink: {
      pointerEvents: 'none',
      cursor: 'default'
    },
    icon: {
      fill: grey[600],
      width: iconSize
    },
    iconDarkMode: {
      fill: `${isDark ? theme.palette.action.active : secondary.main} !important`,
      width: iconSize
    },
    iconDarkModeDisabled: {
      fill: isDark ? theme.palette.action.disabled : grey[600],
      width: iconSize
    },
    infoCard: {
      position: 'relative'
    }
  };
});
